
export default {
  name: 'CourseDescription',
  props: {
    title: {
      type: String,
      required: true
    },
    time: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String],
      required: true
    }
  }
};
